import { render, staticRenderFns } from "./PregnancyHistoryList.vue?vue&type=template&id=12886cc0"
import script from "./PregnancyHistoryList.vue?vue&type=script&lang=js"
export * from "./PregnancyHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports